import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<'pro' | 'basic'>('pro');
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 25,
    s: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section id="pricing" className="py-12 bg-surface border-t border-white/5 relative overflow-hidden" aria-label="Precios y planes" data-id="element-211">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-212">
        <FadeIn data-id="element-213">
          <div className="text-center mb-8" data-id="element-214">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4" data-id="element-215">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className="flex items-center justify-center gap-2 md:gap-4 text-3xl md:text-5xl font-heading font-bold text-gold mb-8" data-id="element-216">
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-217">
                {formatTime(timeLeft.h)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-218">
                  hs
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-219">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-220">
                {formatTime(timeLeft.m)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-221">
                  min
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-222">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-223">
                {formatTime(timeLeft.s)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-224">
                  seg
                </span>
              </div>
            </div>
            <p className="text-red-400 mt-4 font-medium" data-id="element-225">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-226">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8" data-id="element-227">
            ELEGÍ TU <span className="text-gold" data-id="element-228">PACK</span>
          </h2>
        </FadeIn>

        <div id="elegir-plan" className="max-w-2xl mx-auto mb-12" role="radiogroup" aria-label="Seleccionar plan" data-id="element-229">
          <FadeIn delay={0.05} data-id="element-230">
            <div className="mb-6" data-id="element-231">
              <div className="flex justify-between text-sm mb-2" data-id="element-232">
                <span className="text-red-400 font-bold flex items-center gap-2" data-id="element-233">
                  <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-234"></span>
                  Cupos al precio de lanzamiento — Quedan pocos
                </span>
                <span className="text-gray-400" data-id="element-235">68%</span>
              </div>
              <div className="w-full bg-surfaceLight rounded-full h-2.5 overflow-hidden border border-white/5" data-id="element-236">
                <div className="bg-gold h-2.5 rounded-full" style={{
                width: '68%'
              }} data-id="element-237"></div>
              </div>
              <p className="text-xs text-gray-500 mt-2 text-center" data-id="element-238">
                68% de los cupos al precio de lanzamiento ya tomados
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-239">
            <button onClick={() => setSelectedPlan('basic')} role="radio" aria-checked={selectedPlan === 'basic'} className={`w-full text-left rounded-2xl p-6 mb-4 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'basic' ? 'border-gold shadow-[0_0_25px_rgba(234,122,46,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-240">
              <div className="flex items-start gap-4" data-id="element-241">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'basic' ? 'border-gold' : 'border-gray-500'}`} data-id="element-242">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-243"></div>}
                </div>
                <div className="flex-1 min-w-0" data-id="element-244">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-245">
                    <div data-id="element-246">
                      <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-247">
                        <span data-id="element-248">📘</span> MEGAPACK HERRERÍA BLINDADA
                      </h3>
                      <p className="text-gray-400 text-sm mb-3" data-id="element-249">
                        6 Tomos + 3 Bonos
                      </p>
                      <div className="bg-surfaceLight/50 px-3 py-2 rounded-lg border border-white/5 text-xs text-gray-300 inline-block" data-id="element-250">
                        <span className="font-semibold text-white" data-id="element-251">
                          Ideal para:
                        </span>{' '}
                        Herreros que quieren costos, presupuestos y planos
                        claros
                      </div>
                    </div>
                    <div className="sm:text-right shrink-0" data-id="element-252">
                      <span aria-hidden="true" className="text-gray-500 line-through text-sm block" data-id="element-253">
                        $35.000
                      </span>
                      <span className="text-3xl font-bold text-white font-heading" data-id="element-254">
                        $19.990
                      </span>
                      <span className="text-sm text-gray-400 ml-1" data-id="element-255">ARS</span>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-256">
            <div className="relative" data-id="element-257">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-258">
                <span className="bg-gold text-background font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-259">
                  Más Elegido ⭐
                </span>
              </div>
              <button onClick={() => setSelectedPlan('pro')} role="radio" aria-checked={selectedPlan === 'pro'} className={`w-full text-left rounded-2xl p-6 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'pro' ? 'border-gold shadow-[0_0_25px_rgba(234,122,46,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-260">
                <div className="flex items-start gap-4" data-id="element-261">
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'pro' ? 'border-gold' : 'border-gray-500'}`} data-id="element-262">
                    {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-263"></div>}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-264">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-265">
                      <div data-id="element-266">
                        <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-267">
                          <span data-id="element-268">🏆</span> MEGAPACK + EL DIBUJARIO{' '}
                          <span className="text-yellow" data-id="element-269">⭐</span>
                        </h3>
                        <p className="text-gold text-sm font-medium mb-3" data-id="element-270">
                          6 Tomos + 3 Bonos + Pack Maestro de Diseños y Fichas
                          Técnicas
                        </p>
                        <div className="bg-gold/5 px-3 py-2 rounded-lg border border-gold/20 text-xs text-gray-300 inline-block" data-id="element-271">
                          <span className="font-semibold text-white" data-id="element-272">
                            Ideal para:
                          </span>{' '}
                          Herreros que quieren cerrar más ventas con diseños
                          profesionales
                        </div>
                      </div>
                      <div className="sm:text-right shrink-0" data-id="element-273">
                        <span aria-hidden="true" className="text-gray-500 line-through text-sm block" data-id="element-274">
                          $50.000
                        </span>
                        <span className="text-3xl font-bold text-gold font-heading" data-id="element-275">
                          $29.990
                        </span>
                        <span className="text-sm text-gold/70 ml-1" data-id="element-276">ARS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-277">
            <a id="cta-comprar" href={selectedPlan === 'pro' ? 'https://fegion.shop/cart/46879786270859:1' : 'https://fegion.shop/cart/46879780733067:1'} target="_blank" rel="noopener noreferrer" className="block w-full mt-6 py-5 text-center rounded-2xl font-bold text-background bg-gold hover:bg-gold/90 transition-colors shadow-lg uppercase tracking-wider text-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-278">
              {selectedPlan === 'pro' ? '→ QUIERO EL PACK COMPLETO CON EL DIBUJARIO' : '→ QUIERO MI MEGAPACK AHORA'}
            </a>
          </FadeIn>
        </div>

        <FadeIn delay={0.2} data-id="element-279">
          <div className="max-w-4xl mx-auto mb-12" data-id="element-280">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center" data-id="element-281">
              🔩 ¿QUÉ AGREGA EL DIBUJARIO?
            </h3>
            <p className="text-gray-400 text-center mb-6" data-id="element-282">
              El sistema para mostrar diseños que enamoran al cliente y cerrar
              la seña en el acto
            </p>
            <p className="text-sm text-gray-400 mb-2 md:hidden text-center" data-id="element-283">
              ← Deslizá para ver la tabla →
            </p>
            <div className="overflow-x-auto pb-4" data-id="element-284">
              <table className="w-full min-w-[600px] text-left border-collapse" data-id="element-285">
                <thead data-id="element-286">
                  <tr data-id="element-287">
                    <th className="p-4 border-b border-white/10 text-gray-300 font-semibold bg-surfaceLight/30 rounded-tl-xl" data-id="element-288">
                      Situación en la visita
                    </th>
                    <th className="p-4 border-b border-white/10 text-red-400 font-semibold bg-red-500/5" data-id="element-289">
                      ❌ Sin El Dibujario
                    </th>
                    <th className="p-4 border-b border-white/10 text-gold font-semibold bg-gold/5 rounded-tr-xl" data-id="element-290">
                      ✅ Con El Dibujario
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm md:text-base" data-id="element-291">
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-292">
                    <td className="p-4 text-gray-300" data-id="element-293">
                      El cliente pide ver algo moderno
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-294">
                      Buscás fotos en Google sin criterio
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-295">
                      Abrís el catálogo en el celular y mostrás 50 diseños
                      profesionales
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-296">
                    <td className="p-4 text-gray-300" data-id="element-297">
                      El cliente no entiende cómo va a quedar
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-298">
                      Dibujás a mano alzada en un papel
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-299">
                      Mostrás el plano técnico del diseño elegido
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-300">
                    <td className="p-4 text-gray-300" data-id="element-301">
                      Necesitás saber qué material comprar
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-302">
                      Calculás de cabeza en la visita
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-303">
                      Consultás la lista de material del diseño elegido
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-304">
                    <td className="p-4 text-gray-300" data-id="element-305">
                      El cliente compara precio con otro taller
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-306">
                      Competís por precio sin diferenciación
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-307">
                      El cliente eligió TU diseño. Ya no compara
                    </td>
                  </tr>
                  <tr className="hover:bg-white/5 transition-colors" data-id="element-308">
                    <td className="p-4 text-gray-300 rounded-bl-xl" data-id="element-309">
                      Querés presupuestar rápido en obra
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-310">
                      Esperás volver al taller
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium rounded-br-xl" data-id="element-311">
                      Combinás el diseño con el sistema del MegaPack y das
                      precio en minutos
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-312">
          <div className="max-w-4xl mx-auto mb-12 bg-surfaceLight/30 rounded-3xl p-8 border border-white/5" data-id="element-313">
            <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-314">
              ✅ EL DIBUJARIO INCLUYE:
            </h3>
            <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-315">
              {['50 diseños profesionales listos para la visita', 'Planos técnicos de cada diseño', 'Listas de material por diseño', 'Guía de combinación de materiales premium', 'Protocolo para cerrar la seña en el acto', 'Actualizaciones trimestrales sin cargo'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-background/50 p-4 rounded-xl border border-white/5" data-id="element-316">
                  <span className="text-gray-300" data-id="element-317">{item}</span>
                </div>)}
            </div>
            <div className="bg-background/60 rounded-2xl p-6 border border-gold/20" data-id="element-318">
              <p className="text-gray-300 italic leading-relaxed" data-id="element-319">
                "Con El Dibujario mostrás el catálogo en el celular, el cliente
                elige su diseño y cerrás la seña en el acto. Por $10.000 extra
                te llevás 50 diseños con planos y listas de material listos para
                usar."
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-320">
          <div className="max-w-5xl mx-auto mb-12" data-id="element-321">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center" data-id="element-322">
              ❤️ MÁS HERREROS QUE YA LO TIENEN
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-323">
              {[{
              name: 'Fabián C.',
              loc: '📍 Lomas de Zamora',
              plan: 'Herrero independiente',
              text: 'El método del kilo del Tomo 1 me cambió la manera de presupuestar. Ahora sé exactamente cuánto gano antes de comprar el primer caño.'
            }, {
              name: 'Ramiro T.',
              loc: '📍 Córdoba Capital',
              plan: 'Taller de Herrería',
              text: 'La cláusula gatillo del Tomo 4 me salvó en plena suba del dólar. El cliente ya sabía desde el principio cómo funcionaba el ajuste y no hubo conflicto.'
            }, {
              name: 'Hernán B.',
              loc: '📍 Rosario',
              plan: 'Herrería y Rejas',
              text: 'Las tablas del Tomo 3 las tengo pegadas en el taller. Calculo el peso de cualquier perfil en 10 segundos sin calculadora.'
            }, {
              name: 'Walter O.',
              loc: '📍 San Juan',
              plan: 'Dueño de taller',
              text: 'El Dibujario fue lo mejor. Le muestro los diseños al cliente en la visita y el 8 de cada 10 elige uno y me da la seña ahí mismo.'
            }].map((t, i) => <div key={i} className="bg-surfaceLight p-6 rounded-2xl border border-white/5" data-id="element-324">
                  <div className="flex gap-1 mb-3" data-id="element-325">
                    {[...Array(5)].map((_, j) => <span key={j} className="text-yellow text-sm" data-id="element-326">
                        ★
                      </span>)}
                  </div>
                  <p className="text-gray-300 mb-4 italic" data-id="element-327">"{t.text}"</p>
                  <div className="text-sm" data-id="element-328">
                    <span className="font-bold text-white" data-id="element-329">{t.name}</span>
                    <span className="text-gray-500 mx-2" data-id="element-330">|</span>
                    <span className="text-gray-400" data-id="element-331">{t.loc}</span>
                    <span className="text-gray-500 mx-2" data-id="element-332">|</span>
                    <span className="text-gold text-xs" data-id="element-333">{t.plan}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-334">
          <div className="max-w-3xl mx-auto bg-surfaceLight/50 rounded-3xl p-8 md:p-12 border border-white/5 text-center" data-id="element-335">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/5 mb-6 text-4xl" data-id="element-336">
              🛡️
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-337">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h3>
            <p className="text-gray-300 text-lg mb-6" data-id="element-338">
              Abrís los tomos. Los usás en el taller. Si en 7 días no es lo que
              esperabas:
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6 text-white font-medium" data-id="element-339">
              <div className="flex items-center justify-center gap-2" data-id="element-340">
                <span className="text-green-400" data-id="element-341">✅</span> devolución del 100%
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-342">
                <span className="text-green-400" data-id="element-343">✅</span> sin formularios, sin
                drama.
              </div>
            </div>
            <div className="inline-block bg-background px-4 py-2 rounded-lg border border-white/10 text-sm text-gray-400" data-id="element-344">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-345">
          <div className="max-w-3xl mx-auto mt-12" data-id="element-346">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-347">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h3>
            <div className="space-y-4" data-id="element-348">
              {[{
              q: '¿Sirve si trabajo solo sin ayudantes?',
              a: 'Sí, totalmente. El sistema está diseñado para que un herrero solo pueda cobrar bien, presupuestar rápido y trabajar con margen real. Cuando sumes ayudantes, ya tenés las tablas y checklists listos para delegar.'
            }, {
              q: '¿Cómo recibo el material?',
              a: '100% digital. Apenas completás el pago recibís un email con acceso inmediato a todos los PDFs. Lo descargás en tu celular, tablet o computadora y lo tenés para siempre.'
            }, {
              q: '¿Puedo imprimirlo?',
              a: 'Sí. Todo el sistema está diseñado para imprimirse. Las tablas, fórmulas y checklists están pensados para estar plastificados en la pared del taller o en el maletín de obra.'
            }, {
              q: '¿Sirve si recién empiezo en la herrería?',
              a: 'Sí. Si recién arrancás, es la forma más rápida de aprender a cobrar bien desde el día uno. Si ya tenés años en el oficio, vas a encontrar el sistema que te faltaba para dejar de presupuestar a ojo.'
            }, {
              q: '¿Las tablas del Tomo 3 incluyen todos los perfiles?',
              a: 'Sí. Caños redondos, cuadrados, rectangulares, hierros redondos, ángulos, planchuelas, chapas y perfiles estructurales. Todos los formatos comerciales que vas a encontrar en Argentina.'
            }, {
              q: '¿Tiene garantía real?',
              a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, escribinos y te devolvemos el 100% sin preguntas.'
            }].map((faq, i) => <div key={i} className="bg-surfaceLight border border-white/5 rounded-xl overflow-hidden" data-id="element-349">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-gold" aria-expanded={openFaq === i} data-id="element-350">
                    <span className="font-medium text-white pr-4" data-id="element-351">{faq.q}</span>
                    <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-352" />
                  </button>
                  {openFaq === i && <div className="px-6 pb-4 text-gray-400" data-id="element-353">{faq.a}</div>}
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}